// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const mimikyu_busted: PokeData = {
  "id": 10143,
  "name": "mimikyu-busted",
  "height": 2,
  "weight": 7,
  "base_experience": 167,
  "types": [
    PokeType.GHOST,
    PokeType.FAIRY
  ],
  "api_moves": [
    "scratch",
    "mimic",
    "double-team",
    "splash",
    "slash",
    "feint-attack",
    "charm",
    "pain-split",
    "astonish",
    "copycat",
    "shadow-claw",
    "shadow-sneak",
    "wood-hammer",
    "hone-claws",
    "play-rough",
    "baby-doll-eyes"
  ],
  "moves": [
    "scratch",
    "splash",
    "shadow-sneak",
    "wood-hammer",
    "play-rough",
    "spirit-break",
    "confuse-ray",
    "misty-terrain",
    "heal-bell",
    "guardian-bond",
    "shadow-ball",
    "moonlight",
    "sweet-kiss"
  ],
  "evolution_chain": {
    "id": 404,
    "item": null,
    "species": [
      {
        "name": "mimikyu",
        "order": 778,
        "types": [
          PokeType.GHOST,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 114,
    "speed": 148,
    "ability_power": 139
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
